import firebase from '../firebase';

const database = firebase.database();
const _getDuas = duas => ({
  type: 'GET_DUAS',
  duas,
});

const _getVideos = videos => ({
  type: 'GET_VIDEOS',
  videos,
});

const _getEvents = events => ({
  type: 'GET_EVENTS',
  events,
});

const _getCategories = categories => ({
  type: 'GET_CATEGORIES',
  categories,
});

const _addDua = dua => ({
  type: 'ADD_DUA',
  dua,
});

const _updateDuaById = (id, duaObj) => ({
  type: 'UPDATE_DUA',
  id,
  duaObj,
});
const _updateVideoById = (id, videoObj) => ({
  type: 'UPDATE_VIDEO',
  id,
  videoObj,
});
const _updateEventById = (id, eventObj) => ({
  type: 'UPDATE_EVENT',
  id,
  eventObj,
});
const _getListByCategory = list => ({
  type: 'GET_SECTION_LIST',
  list,
});

const _addVideo = video => ({
  type: 'ADD_VIDEO',
  video,
});

const _addEvent = event => ({
  type: 'ADD_EVENT',
  event,
});

const _addEmail = email => ({
  type: 'ADD_EMAIL',
  email,
});
const _setLiveStreamURL = bayansList => ({
  type: 'GET_STREAM_URL',
  bayansList,
});

const _addLiveStreamingURL = url => ({
  type: 'ADD_STREAM_URL',
  url,
});
export const addDua = (
  dua = {
    name: '',
    category: '',
    date: '',
    imageURL: '',
    title: '',
  }
) => {
  return dispatch => {
    const duaObj = {
      name: dua.name,
      category: dua.category,
      date: dua.date,
      imageURL: dua.imageURL,
      title: dua.title,
    };

    return database
      .ref('Dua')
      .push(duaObj)
      .then(ref => {
        dispatch(
          _addDua({
            id: ref.key,
            ...duaObj,
          })
        );
      });
  };
};

const _removeRecord = ({ id, category } = {}) => ({
  type: 'REMOVE_RECORD',
  id,
  category,
});
const _removeLiveStreamURL = url => ({
  type: 'REMOVE_LIVE_STREAMING_URL',
  url,
});

export const getListByCategory = category => {
  return dispatch => {
    return database
      .ref(`${category}`)
      .once('value')
      .then(snapshot => {
        const list = [{}];
        snapshot.forEach(item => {
          list.push({
            id: item.key,
            length: snapshot.numChildren(),
            ...item.val(),
          });
        });
        list.shift();
        dispatch(_getListByCategory(list));
      });
  };
};

export const getDuas = () => {
  return dispatch => {
    return database
      .ref('Dua')
      .once('value')
      .then(snapshot => {
        const duas = [{}];
        snapshot.forEach(item => {
          duas.push({
            id: item.key,
            length: snapshot.numChildren(),
            ...item.val(),
          });
        });
        duas.shift();
        dispatch(_getDuas(duas));
      });
  };
};

export const addVideo = (
  video = {
    name: '',
    date: '',
    title: '',
    category: '',
    videoURL: '',
  }
) => {
  return dispatch => {
    const videoObj = {
      name: video.name,
      date: video.date,
      title: video.title,
      category: video.category,
      videoURL: video.videoURL,
    };

    return database
      .ref('Video')
      .push(videoObj)
      .then(ref => {
        dispatch(
          _addVideo({
            id: ref.key,
            ...videoObj,
          })
        );
      });
  };
};

export const addEvent = (
  event = {
    name: '',
    date: '',
    time: '',
    address: '',
    eventURL: '',
  }
) => {
  return dispatch => {
    const eventObj = {
      name: event.name,
      date: event.date,
      time: event.time,
      address: event.address,
      eventURL: event.eventURL,
    };

    return database
      .ref('Event')
      .push(eventObj)
      .then(ref => {
        dispatch(
          _addEvent({
            id: ref.key,
            ...eventObj,
          })
        );
      });
  };
};

export const getDuaById = (id = {}) => {
  return dispatch => {
    return database
      .ref(`Dua/${id}`)
      .once('value')
      .then(snapshot => {
        dispatch(_getDuas(snapshot.val()));
      });
  };
};

export const updateDuaById = (id, duaObj) => {
  return dispatch => {
    return database
      .ref(`Dua/${id}`)
      .update(duaObj)
      .then(() => {
        dispatch(_updateDuaById(id, duaObj));
      });
  };
};

export const getVideoById = (id = {}) => {
  return dispatch => {
    return database
      .ref(`Video/${id}`)
      .once('value')
      .then(snapshot => {
        dispatch(_getVideos(snapshot.val()));
      });
  };
};

export const updateVideoById = (id, videoObj) => {
  return dispatch => {
    return database
      .ref(`Video/${id}`)
      .update(videoObj)
      .then(() => {
        dispatch(_updateVideoById(id, videoObj));
      });
  };
};

export const getEventById = (id = {}) => {
  return dispatch => {
    return database
      .ref(`Event/${id}`)
      .once('value')
      .then(snapshot => {
        dispatch(_getEvents(snapshot.val()));
      });
  };
};

export const updateEventById = (id, eventObj) => {
  return dispatch => {
    return database
      .ref(`Event/${id}`)
      .update(eventObj)
      .then(() => {
        dispatch(_updateEventById(id, eventObj));
      });
  };
};

export const deleteRecord = (id, category) => {
  return dispatch => {
    return database
      .ref(`${category}/${id}`)
      .remove()
      .then(() => {
        dispatch(_removeRecord({ id, category }));
      });
  };
};

export const getLiveStreamingURL = () => {
  return dispatch => {
    return database
      .ref(`live_streaming_url`)
      .once('value')
      .then(urlSnapshot => {
        return database
          .ref(`message`)
          .once('value')
          .then(snapshot => {
            const message = {
              message: snapshot.val(),
              url: urlSnapshot.val(),
            };
            dispatch(_setLiveStreamURL(message));
          });
      });
  };
};

export const addLiveStreamingURL = (url, message) => {
  return dispatch => {
    return database
      .ref(`live_streaming_url`)
      .set(url)
      .then(() => {
        return database
          .ref(`message`)
          .set(message)
          .then(ref => {
            dispatch(
              _addLiveStreamingURL({
                ...message,
              })
            );
          });
      });
  };
};

export const updateLiveStreamingURL = (url, message) => {
  return dispatch => {
    return database
      .ref(`live_streaming_url`)
      .update(url)
      .then(snapshot => {
        return database
          .ref(`live_streaming_url`)
          .update(message)
          .then(snapshot => {
            dispatch(_setLiveStreamURL(snapshot.val()));
          });
      });
  };
};

export const deleteLiveStreamingURL = url => {
  return dispatch => {
    return database
      .ref(`live_streaming_url`)
      .remove()
      .then(() => {
        dispatch(_removeLiveStreamURL({ url }));
      });
  };
};

export const getBayansByCategory = category => {
  if (category !== 'All') {
    return dispatch => {
      return database
        .ref(`Video`)
        .orderByChild('category')
        .equalTo(`${category}`)
        .once('value')
        .then(snapshot => {
          const list = [{}];
          snapshot.forEach(function(childSnapshot) {
            var bayansList = childSnapshot.val();
            list.push({
              id: childSnapshot.key,
              ...bayansList,
            });
          });
          list.shift();
          dispatch(_setLiveStreamURL(list));
        });
    };
  } else {
    return dispatch => {
      return database
        .ref(`Video`)
        .orderByChild('date')
        .once('value')
        .then(snapshot => {
          const list = [{}];
          //go through each item found and print out the emails
          snapshot.forEach(function(childSnapshot) {
            var bayansList = childSnapshot.val();
            list.push({
              id: childSnapshot.key,
              ...bayansList,
            });
          });
          list.shift();
          dispatch(_setLiveStreamURL(list));
        });
    };
  }
};

export const getDuaByCategory = category => {
  if (category !== 'All') {
    return dispatch => {
      return database
        .ref(`Dua`)
        .orderByChild('category')
        .equalTo(`${category}`)
        .once('value')
        .then(snapshot => {
          const list = [{}];
          //go through each item found and print out the emails
          snapshot.forEach(function(childSnapshot) {
            var duaList = childSnapshot.val();
            list.push({
              id: childSnapshot.key,
              ...duaList,
            });
          });
          list.shift();
          dispatch(_getDuas(list));
        });
    };
  } else {
    return dispatch => {
      return database
        .ref(`Dua`)
        .orderByChild('date')
        .once('value')
        .then(snapshot => {
          const list = [{}];
          //go through each item found and print out the emails
          snapshot.forEach(function(childSnapshot) {
            var duaList = childSnapshot.val();
            list.push({
              id: childSnapshot.key,
              ...duaList,
            });
          });
          list.shift();
          dispatch(_getDuas(list));
        });
    };
  }
};

export const getAllEvents = () => {
  return dispatch => {
    return database
      .ref(`Event`)
      .orderByChild('date')
      .once('value')
      .then(snapshot => {
        const list = [{}];
        //go through each item found and print out the emails
        snapshot.forEach(function(childSnapshot) {
          var evetList = childSnapshot.val();
          list.push({
            id: childSnapshot.key,
            ...evetList,
          });
        });
        list.shift();
        dispatch(_getEvents(list));
      });
  };
};

export const addSubscriptionMails = emailId => {
  const emailObj = {
    EmailId: emailId,
    SubscribedDate: new Date().toLocaleDateString(),
  };
  return dispatch => {
    return database
      .ref('SubscribedEmailIds')
      .push(emailObj)
      .then(ref => {
        //dispatch(_addEmail(emailObj));
      });
  };
};

export const getCategoryList = () => {
  return dispatch => {
    return database
      .ref(`Categories`)
      .orderByValue()
      .once('value')
      .then(snapshot => {
        const list = [{}];
        snapshot.forEach(item => {
          list.push({
            id: item.key,
            ...item.val(),
          });
        });
        list.shift();
        dispatch(_getCategories(list));
      });
  };
};
